import { api } from '@fno/service/global.js'
import { cloneDeep, set, get } from 'lodash'
import { patchSchool, getSchool } from '@fno/service/api/schools.js'

export const getAffiliations = ({ schoolId }) => api
    .get(`/v2/schools/${schoolId}/affiliations`)
    .then(response => response.data)

export const patchAffiliations = ({ affiliations }) => api
    .patch(`/v2/schools/${affiliations.meta.schoolId}/affiliations`, { data: affiliations })
    .then(response => response.data)
    .then(data => {
        if (Object.keys(get(data, 'attributes.affiliations')).length) {
            updateSchoolObject({ schoolId: data.meta.schoolId })
        }
    })

const updateSchoolObject = ({ schoolId }) => {
    getSchool({ schoolId })
        .then((school) => {
            const updatedSchool = cloneDeep(school)
            set(updatedSchool, 'attributes.featuresEnabledInApp.affiliations', true)
            patchSchool({ school: updatedSchool })
        })
}